
<template>
  <v-dialog v-model="dialog" transition="dialog-bottom-transition" scrollable>
    <template v-if="!hideButton" v-slot:activator="{ props }">
      <v-btn
             color="primary"
             :class="{ 'float-right': floatRight }"
             v-bind="props"><v-icon class="mr-2">mdi-plus</v-icon> Evento</v-btn>
    </template>
    <v-card>
      <v-toolbar color="primary" :title="value.id ? 'Editar evento' : 'Novo evento'">
        <v-btn color="black" @click="dialog = false"><v-icon>mdi-close</v-icon></v-btn>
      </v-toolbar>
      <v-card-text>
        <FormEvent :user="user" v-model="value" @created="createdObject" @updated="updatedObject" />
      </v-card-text>
      <v-card-actions class="justify-end">
        <v-btn variant="text" color="error" @click="dialog = false">Cancelar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import FormEvent from './FormEvent.vue';
export default {
  components: { FormEvent },
  props: {
    user: Object,
    modelValue: Object,
    floatRight: Boolean,
    hideButton: Boolean,
  },
  emits: ["update:modelValue"],
  data() {
    return {
      dialog: false,
    };
  },
  mounted() { },
  activated() { },
  methods: {
    createdObject(val) {
      this.$emit("created", val);
    },
    updatedObject(val) {
      this.$emit("updated", val);
    },
  },
  computed: {
    value: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },
  watch: {
    dialog(newVal) {
      if (!newVal) {
        this.value = {}
      }
    },
    modelValue(newVal) {
      if (newVal && newVal?.id && !this.dialog) {
        this.dialog = true;
      }
    },
  },
};
</script>
